import Vue from 'vue'
import Router from 'vue-router'

const RegisterYourInterest = () => import('../components/views/public/RegisterYourInterest.vue')
const PublicView = () => import('../components/views/public/PublicView.vue')
const TermsAndConditions = () => import('../components/views/public/TermsAndConditions.vue')
const SuccessPage = () => import('../components/views/public/SuccessPage.vue')

const Login = () => import('../components/views/LoginPage.vue')
const NurseDashboard = () => import('../components/views/admin/NurseDashboard.vue')
const QuickActions = () => import('../components/nurse/QuickActions.vue')
const PatientsOverview = () => import('../components/nurse/PatientsOverview.vue')
const FormsOverview = () => import('../components/nurse/FormsOverview.vue')
const PatientDetails = () => import('../components/views/admin/PatientDetails.vue')
// const UpcomingEvents = () => import('../components/nurse/UpcomingEvents.vue')
const UpcomingInjections = () => import('../components/nurse/UpcomingInjections.vue')
const UpcomingAppointments = () => import('../components/nurse/UpcomingAppointments.vue')
const PageNotFound = () => import('../components/views/PageNotFound.vue')

const AdverseEventForm = () => import('../components/nurse/AdverseEventForm.vue')
const PatientForm = () => import('../components/forms/PatientForm.vue')
const ScheduleInjectionsForm = () => import('../components/forms/ScheduleInjectionsForm.vue')
const RescheduleInjectionsForm = () => import('../components/forms/RescheduleInjectionsForm.vue')
const PatientEventForm = () => import('../components/forms/PatientEventForm.vue')

// const PatientEvents = () => import('../components/patients/PatientEvents.vue')
const PatientInjections = () => import('../components/patients/PatientInjections.vue')
const PatientAppointments = () => import('../components/patients/PatientAppointments.vue')
const PatientAssessments = () => import('../components/patients/PatientAssessments.vue')
const ReadOnlyAssessment = () => import('../components/forms/Assessment.vue')
const AdminBaseline = () => import('../components/views/assessment/AdminBaseline.vue')
const BaselineAssessment = () => import('../components/views/assessment/PatientBaseline.vue')
const AdminRecurring = () => import('../components/views/assessment/AdminRecurring.vue')
const RecurringAssessment = () => import('../components/views/assessment/PatientRecurring.vue')
const PatientResultsPage = () => import('../components/views/assessment/PatientResultsPage.vue')

Vue.use(Router)

export default new Router({
  mode: process.env.NODE_ENV === 'development' ? 'history' : 'hash',
  routes: [
    // Public
    {
      path: '/public',
      alias: '/',
      component: PublicView,
      children: [
        {
          path: 'register',
          name: 'RegisterInterest',
          component: RegisterYourInterest,
          meta: { requiresAuth: false }
        },
        {
          path: 'register/success',
          name: 'RegisterSuccess',
          component: SuccessPage,
          meta: { requiresAuth: false }
        },
        {
          path: 'toc',
          name: 'TermsAndConditions',
          component: TermsAndConditions,
          meta: { requiresAuth: false }
        },
        {
          path: '/enroll/success',
          name: 'EnrollSuccessPage',
          component: SuccessPage,
          meta: { requiresAuth: false }
        },
        // // NOTE: For patients filling in baseline assessments themselves
        {
          path: 'assessments/baseline/token/:token',
          name: 'PatientBaseline',
          component: BaselineAssessment,
          meta: { requiresAuth: false },
          props: true
        },
        // NOTE: For patients filling in recurring assessments themselves
        {
          path: 'assessments/:identifier/token/:token',
          name: 'PatientRecurring',
          component: RecurringAssessment,
          meta: { requiresAuth: false },
          props: true
        },
        {
          path: 'assessment/:identifier/success/token/:token/',
          name: 'PatientAssessmentSuccessPage',
          component: SuccessPage,
          meta: { requiresAuth: false },
          props: true
        },
        {
          path: 'assessments/:identifier/results/token/:token',
          name: 'PatientRecurringResults',
          component: PatientResultsPage,
          meta: { requiresAuth: false },
          props: true
        }
      ]
    },
    // Admin CRUD
    // NOTE: For administrators filling in baseline assessment for patients
    {
      path: '/admin/patients/:username/assessments/baseline',
      name: 'AdminBaseline',
      component: AdminBaseline,
      props: true,
      meta: { requiresAuth: true } // REF: https://router.vuejs.org/guide/advanced/meta.html
    },
    // NOTE: For administrators filling in recurring assessment for patients
    {
      path: '/admin/patients/:username/assessments/:identifier',
      name: 'AdminRecurring',
      component: AdminRecurring,
      props: true,
      meta: { requiresAuth: true } // REF: https://router.vuejs.org/guide/advanced/meta.html
    },
    {
      path: '/admin/patients/:username/assessments/baseline/success',
      name: 'AdminBaselineSuccessPage',
      component: SuccessPage,
      meta: { requiresAuth: true }
    },
    {
      path: '/admin/patients/create',
      name: 'CreatePatient',
      component: PatientForm,
      meta: { requiresAuth: true }
    },
    {
      path: '/admin/patients/:username/events/injections/create',
      name: 'CreateInjectionEvent',
      component: PatientEventForm,
      props: true,
      meta: { requiresAuth: true }
    },
    {
      path: '/admin/patients/:username/events/injections/edit',
      name: 'EditInjectionEvent',
      component: PatientEventForm,
      props: true,
      meta: { requiresAuth: true }
    },
    {
      path: '/admin/patients/:username/events/appointments/create',
      name: 'CreateAppointmentEvent',
      component: PatientEventForm,
      props: true,
      meta: { requiresAuth: true }
    },
    {
      path: '/admin/patients/:username/events/appointments/edit',
      name: 'EditAppointmentEvent',
      component: PatientEventForm,
      props: true,
      meta: { requiresAuth: true }
    },
    {
      path: '/admin/patients/:username/events/injections/schedule',
      name: 'ScheduleInjections',
      component: ScheduleInjectionsForm,
      props: true,
      meta: { requiresAuth: true }
    },
    {
      path: '/admin/patients/:username/events/injections/reschedule',
      name: 'RescheduleInjections',
      component: RescheduleInjectionsForm,
      props: true,
      meta: { requiresAuth: true }
    },
    {
      path: '/admin/patients/:username',
      name: 'ViewPatient',
      redirect: { name: 'PatientProfile' },
      component: PatientDetails,
      meta: { requiresAuth: true },
      props: true,
      children: [
        {
          path: 'profile',
          name: 'PatientProfile',
          component: PatientForm,
          props: true
        },
        // {
        //   path: 'events',
        //   name: 'PatientEvents',
        //   component: PatientEvents
        // },
        {
          path: 'injections',
          name: 'PatientInjections',
          component: PatientInjections
        },
        {
          path: 'appointments',
          name: 'PatientAppointments',
          component: PatientAppointments
        },
        {
          path: 'assessments',
          name: 'PatientAssessments',
          component: PatientAssessments,
          children: [
            {
              path: 'view/:identifier',
              name: 'ReadOnlyAssessment',
              component: ReadOnlyAssessment,
              props: true
            }
          ]
        }
      ]
    },
    {
      path: '/admin/login',
      name: 'Login',
      component: Login,
      meta: { requiresAuth: false },
      props: true
    },
    // Admin Sections
    {
      path: '/admin',
      redirect: { name: 'PatientsOverview' },
      name: 'NurseDashboard',
      component: NurseDashboard,
      meta: { requiresAuth: true },
      children: [
        // {
        //   path: 'main',
        //   name: 'NurseQuickActions',
        //   component: QuickActions
        // },
        // {
        //   path: 'events',
        //   name: 'UpcomingEvents',
        //   component: UpcomingEvents
        // },
        {
          path: 'appointments',
          name: 'UpcomingAppointments',
          component: UpcomingAppointments
        },
        {
          path: 'injections',
          name: 'UpcomingInjections',
          component: UpcomingInjections
        },
        {
          path: 'patients',
          name: 'PatientsOverview',
          component: PatientsOverview
        },
        {
          path: 'forms',
          name: 'FormsOverview',
          component: FormsOverview,
          children: [
            {
              path: 'ae',
              name: 'AdverseEventForm',
              component: AdverseEventForm
            }
          ]
        },
        {
          path: '*',
          component: PageNotFound
        }
      ]
    }
    // // Redirects
    // { path: '/', redirect: '/register' },
    // { path: '*', redirect: '/register' }
  ]
})



// WEBPACK FOOTER //
// ./src/router/index.js